const STORAGE_KEY = "norm_feature_flags";

const DEFAULT_FLAGS = {
  aiValidationEnabled: true,
  aiRetryEnabled: true,
  aiSchemaValidationEnabled: true,
  aiTelemetryEnabled: true,
  auditTrailServerSyncEnabled: false,
  auditServerPersistenceEnabled: false,
  // PRECISION_PRO escalation: Sonnet → Opus quando confiança baixa.
  // Default false (futuro tier PLUS / autorização explícita).
  precisionAutoEscalation: false,
  // Output mode: false = "analise" (output completo), true = "guia"
  // (pós-processador reduz output em confiança baixa, alinha com postura
  // norteador — auditor recebe sinal honesto, não pseudo-certeza).
  precisionGuideMode: false,
};

function safeRead() {
  if (typeof window === "undefined") return {};
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY) || "{}");
  } catch (e) {
    return {};
  }
}

export function getFeatureFlags() {
  const fromStorage = safeRead();
  return {
    ...DEFAULT_FLAGS,
    ...fromStorage,
  };
}

export function isFeatureEnabled(flagName) {
  return Boolean(getFeatureFlags()[flagName]);
}

export function setFeatureFlag(flagName, enabled) {
  if (typeof window === "undefined") return;
  const current = safeRead();
  const next = { ...current, [flagName]: Boolean(enabled) };
  localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
}
